import { ROUTES } from '@/config/routes';

const irmLink = ROUTES.getLink(`irm`);
const videoconferenceRoomsLink = ROUTES.getLink(`irm.videoconference.rooms`);
const astridConversationsLink = ROUTES.getLink(`irm.astrid.conversations`);
const servicesLink = ROUTES.getLink(`irm.services`);

// Decides where to send someone who opened an `/irm/...` URL they cannot see. The target is
// picked with `hasRoute` itself, so it is never a route that would be denied again, and the order
// follows `startingPage`: IRM, then Webcast, then AI, then "Demais Serviços" (open to everyone in
// the company view). With nothing allowed (the admin view) there is no target, and the caller
// falls back to the starting page.
export const getIrmDeniedRedirect = (hasRoute: (route: string) => boolean) => {
  if (hasRoute(irmLink)) return irmLink;
  if (hasRoute(videoconferenceRoomsLink)) return videoconferenceRoomsLink;
  if (hasRoute(astridConversationsLink)) return astridConversationsLink;
  if (hasRoute(servicesLink)) return servicesLink;

  return undefined;
};
